import Passenger from "./Passenger.vue";
export default Passenger;
